import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";

const apiClient = new APIClient();

const GasFeeCalculator = () => {
  const [gasPrice, setGasPrice] = useState(null);
  const [gasCost, setGasCost] = useState("");
  const [ethPriceUSD, setEthPriceUSD] = useState(2300);
  const [error, setError] = useState(null);

  const fetchGasPrice = useCallback(async () => {
    const response = await apiClient.get("/operacao/get-gas-price");

    if (response.sucesso) {
      setGasPrice(Number(response.dados.ProposeGasPrice).toFixed(6));
      const cost = 21000 * response.dados.ProposeGasPrice * Math.pow(10, -9);
      const costUSD = cost * ethPriceUSD;
      setGasCost(costUSD.toFixed(2) + " USD");
    } else {
      toast.error(response.mensagem);
    }
  }, [ethPriceUSD]);

  useEffect(() => {
    fetchGasPrice();
  }, [fetchGasPrice]);

  return (
    <div>
      {error && <p>Erro: {error}</p>}
      {gasPrice ? (
        <div>
          <p>
            <b>Preço Atual do GAS:</b> {gasPrice} Gwei&nbsp;&nbsp; <br />
            <b>Custo de GAS para Transação Simples:</b> {gasCost}
          </p>
        </div>
      ) : (
        <p>Carregando preço do GAS...</p>
      )}
    </div>
  );
};

export default GasFeeCalculator;
